import React from 'react';
import './Mysterion.css';

const Mysterion = () => {
  return (
    <div className="mysterion-page">
      <div className="header-image-container">
        <img 
          src="/images/mysterion.png" 
          alt="Mysterion" 
          className="header-image"
        />
        <div className="header-overlay">
          <p className="page-subtitle">Exploring the Sacred Mysteries, Mystical Path, and Divine Voices</p>
        </div>
      </div>
      
      {/* Mysticism Section */}
      <section className="content-section mysticism-section" id="mysticism">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="section-title">Mysticism</h2>
              <p className="section-subtitle">Exploring the Mystical Path</p>
              <p>
                Welcome to the realm of mysticism, where the divine meets the human experience. 
                Here we explore the deeper dimensions of spiritual practice and the direct experience 
                of the sacred.
              </p>
              
              <h3>The Mystical Journey</h3>
              <p>
                Mysticism represents the direct, personal experience of the divine presence. 
                It transcends religious boundaries and speaks to the universal human longing 
                for connection with something greater than ourselves.
              </p>
              
              <h3>Ancient Wisdom</h3>
              <p>
                Throughout history, mystics have served as bridges between the material and 
                spiritual worlds, offering insights into the nature of consciousness, 
                transformation, and divine love.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mysteries Section */}
      <section className="content-section mysteries-section" id="mysteries">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="section-title">Mysteries</h2>
              <p className="section-subtitle">Unveiling the Sacred Mysteries</p>
              <p>
                The mysteries represent the hidden dimensions of spiritual truth that 
                have been passed down through generations. These sacred teachings reveal 
                the deeper patterns of creation and our place within the divine order.
              </p>
              
              <h3>The Nature of Mystery</h3>
              <p>
                True mysteries are not meant to be solved, but to be experienced. 
                They invite us into a deeper relationship with the divine, calling us 
                to surrender our need for complete understanding and embrace the wonder 
                of the unknown.
              </p>
              
              <h3>Ancient Traditions</h3>
              <p>
                From the Eleusinian Mysteries to the Kabbalistic traditions, humanity 
                has always sought to understand the sacred through ritual, symbolism, 
                and direct revelation. These practices continue to guide seekers today.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mystics Section */}
      <section className="content-section mystics-section" id="mystics">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <h2 className="section-title">Mystics</h2>
              <p className="section-subtitle">Voices of the Divine</p>
              <p>
                The mystics are those who have experienced direct communion with the divine. 
                Their lives and teachings serve as beacons of light, guiding humanity toward 
                deeper spiritual understanding and transformation.
              </p>
              
              <h3>The Mystic's Path</h3>
              <p>
                Mystics throughout history have walked the path of direct experience, 
                transcending religious dogma to encounter the living presence of God. 
                Their writings and lives continue to inspire seekers across all traditions.
              </p>
              
              <h3>Contemporary Voices</h3>
              <p>
                Today's mystics carry forward the ancient wisdom while speaking to 
                modern challenges. They remind us that the mystical experience is 
                not reserved for the past, but is available to all who seek with 
                an open heart.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Anchors */}
      <div className="section-navigation">
        <div className="container">
          <div className="nav-links">
            <a href="#mysticism" className="nav-link">Mysticism</a>
            <a href="#mysteries" className="nav-link">Mysteries</a>
            <a href="#mystics" className="nav-link">Mystics</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mysterion;